<template>
  <div class="body con-wd">
    <breadcrumb :data="['项目', '创建文档', '业态类型&梯种']"></breadcrumb>
    <div class="container">
      <div class="form-con">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="文档名称" prop="documentName">
            <el-input v-model="form.documentName" placeholder="请输入文档名"></el-input>
          </el-form-item>
          <el-form-item class="business-con" label="业态类型" prop="businessTypeId">
            <el-form-item prop="businessTypeId">
              <el-select @change="handleBusinessTypeChange" v-model="form.businessTypeId" placeholder="请选择">
                <el-option v-for="item in businessTypeList" :key="'btype' + item.bid" :label="item.name"
                  :value="item.bid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="businessId" class="error_form">
              <el-select :style="{ marginLeft: '20px' }" v-model="form.businessId" @change="handleBusinessChange"
                placeholder="请选择">
                <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>

          <el-form-item prop="bulidingHeight">
            <p class="label">
              <el-checkbox v-model="form.checkedHeight">建筑高度</el-checkbox>
            </p>
            <el-input :style="{ width: '200px' }" :disabled="(form.checkedHeight) ? false : true" placeholder="请输入建筑高度" v-model="form.bulidingHeight"></el-input>
          </el-form-item>
          <el-form-item prop="elevatorSeriesIdList">
            <p class="label">
              <el-checkbox v-model="form.checkedSeries" @change="getChangeId">梯种系列</el-checkbox>
            </p>
            <!-- {{ form.elevatorSeriesIdList }} -->
            <el-checkbox-group @change="handleSeriesClick" class="check" v-model="form.elevatorSeriesIdList">
              <!-- <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox> -->
              <el-checkbox :disabled="(form.checkedSeries) ? false : true" :label="item.etId" :key="item.etId" v-for="item in seriesList" name="type">
                {{ item.etName }}
              </el-checkbox>
            </el-checkbox-group>

            <!-- <div class="type-list">
              <div :class="[
                selectedSeries.indexOf(item.etId) > -1 ? 'active' : ''
              ]" @click="handleSeriesClick(item.etId)" v-for="item in seriesList" :key="'series' + item.etId">
                {{ item.etName }}
              </div>
            </div> -->
          </el-form-item>
          <el-form-item prop="elevatorIdList">
            <p class="label">
              <el-checkbox v-model="form.checkedIdList" @change="getChangeType">梯种型号</el-checkbox>
            </p>
            <!-- <div class="type-list">
              <div :class="[selectedTypes.indexOf(item.eId) > -1 ? 'active' : '']" @click="handleTypesClick(item.eId)"
                v-for="item in typeList" :key="'types' + item.eId">
                {{ item.eNum }}
              </div>
            </div> -->
            <!-- {{ form.elevatorIdList }} -->
            <el-checkbox-group class="check" v-model="form.elevatorIdList">
              <!-- <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox> -->
              <el-checkbox :disabled="(form.checkedIdList) ? false : true" :label="item.eId" :key="'types-' + item.eId" v-for="item in typeList" name="type">
                {{ item.eNum }}
              </el-checkbox>
            </el-checkbox-group>

          </el-form-item>
        </el-form>
      </div>
      <div class="boot">
        <el-button @click="prev">上一步</el-button>
        <el-button type="danger"  @click="submit">创建文档</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/pc/Breadcrumb'
import { mapMutations } from 'vuex'
export default {
  name: 'selectType',
  components: {
    Breadcrumb
  },
  beforeCreate() {
    document.body.setAttribute('style', 'background:#F4F4F5;')
  },
  // beforeDestroy() {
  //   document.body.setAttribute('style', 'background:#F4F4F5;')
  // },

  data() {
    return {
      form: {
        businessOpprtunityId: undefined, //商机id
        moduleIdList: [], //模板列表
        documentName: '', //文档名称
        businessTypeId: undefined, //业态类型id
        businessTypeName: '', //业态类型名称
        businessId: undefined, //业态id
        businessName: '', //业态名称
        bulidingHeight: undefined, //建筑高度
        elevatorSeriesIdList: [], //梯种系统id列表
        elevatorIdList: [], //梯种id列表
        checkedHeight:false,
        checkedSeries:false,
        checkedIdList:false,
      },
      rules: {
        documentName: [
          { required: true, message: '请输入文档名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        businessTypeId: [
          { required: true, message: '请选择业态类型', trigger: 'blur' }
        ],
        businessId: [
          { required: true, message: '请选择业态类型', trigger: 'blur' }
        ],
        bulidingHeight: [
          //{ required: true, message: '请输入建筑高度', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        // elevatorSeriesIdList: [
        //   { required: true, message: '请选择梯种系列', trigger: 'blur' }
        // ],
        // elevatorIdList: [
        //   { required: true, message: '请选择梯种型号', trigger: 'blur' }
        // ],
        checkedHeight: [
          { required: true, message: '请选择业态类型', trigger: 'blur' }
        ],
      },
      options: [
        {
          value: '1',
          label: '类型1'
        },
        {
          value: '2',
          label: '类型2'
        },
        {
          value: '3',
          label: '类型3'
        }
      ],
      value: '',
      businessTypeList: [],
      selectTypes: [],
      seriesList: [],
      selectedSeries: [],
      typeList: [],
      selectedTypes: []
    }
  },

  computed: {
    businessList() {
      let result = []
      let bObj = this.businessTypeList.find(
        (item) => item.bid == this.form.businessTypeId
      )
      if (bObj) {
        result = bObj.btList
      }
      return result
    }
  },
  mounted() {
    this.form.businessOpprtunityId = this.$route.params.id

    this.changeMenuStatus({ value: 5 })
    this.getBusinessTypeList()
    this.getElevatorSeriesList()
  },
  methods: {
    ...mapMutations(['changeMenuStatus']),
    getChangeId(e) {
      if(!e) {
        this.form.elevatorSeriesIdList = []
        this.typeList = []
        this.form.checkedIdList = false
      }
    },
    getChangeType(e) {
      if(!e) {
        this.form.elevatorIdList = []
      }
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(valid);
          let moduleIdListStr = localStorage.getItem(
            `moduleIdList-${this.form.businessOpprtunityId}`
          )
          if (moduleIdListStr != null) {
            this.form.moduleIdList = JSON.parse(moduleIdListStr)
          }
          this.$request.createDocument(this.form).then((res) => {
            if (res.code == 200) {
              this.$message.success('添加文档成功')
              // this.$router.push(
              //   `/manage/addcover/${this.form.businessOpprtunityId}`
              // )
              this.$router.push({
                path: '/manage/doclist',
                query: {
                  id: this.form.businessOpprtunityId
                }
              })
            }
          })
        }
      })


      // this.form.elevatorSeriesIdList = this.selectedSeries
      // this.form.elevatorIdList = this.selectedTypes

    },
    getBusinessTypeList() {
      this.$request.getBusinessTypeList().then((res) => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            // if (res.data[0].bid == null) {
            //   res.data[0].bid = 100000
            // }
            this.businessTypeList = res.data[0].btList
          }
        }
      })
    },
    getElevatorSeriesList() {
      this.$request.getElevatorSeriesList().then((res) => {
        if (res.code == 200) {
          console.log(res, '电梯种类')
          this.seriesList = res.data
        }
      })
    },
    getElevatorTypeList() {
      this.form.elevatorIdList = []
      if (this.form.elevatorSeriesIdList.length == 0) {
        this.typeList = []
        return
      }


      this.$request
        .getElevatorTypeList({ etIds: this.form.elevatorSeriesIdList })
        .then((res) => {
          if (res.code == 200) {
            this.typeList = res.data
          }
        })
    },
    handleBusinessTypeChange(bid) {
      console.log(bid)
      let obj = this.businessTypeList.find((item) => item.bid == bid)
      this.form.businessTypeName = obj.name
      this.form.businessId = undefined
    },
    handleBusinessChange(id) {
      let obj = this.businessList.find((item) => item.id == id)
      this.form.businessName = obj.name
    },
    // 梯种型号
    handleTypesClick(eId) {
      console.log(eId, '选上的梯种')
      const index = this.selectedTypes.indexOf(eId)
      console.log(index)
      if (index > -1) {
        this.selectedTypes.splice(index, 1)
      } else {
        this.selectedTypes.push(eId)
      }
      console.log(this.selectedTypes, 'selectTypes')
    },
    // 梯种系列
    handleSeriesClick() {
      // const index = this.selectedSeries.indexOf(etId)
      // if (index > -1) {
      //   this.typeList.forEach(item => {
      //     if (item.etId === etId) {
      //       this.selectedTypes.forEach((val, num) => {
      //         if (val === item.eId) {
      //           this.selectedTypes.splice(num, 1)
      //         }
      //       })
      //     }
      //   })
      //   this.selectedSeries.splice(index, 1)
      // } else {
      //   this.selectedSeries.push(etId)
      // }
      // console.log(this.selectedSeries, 'selectedSeries')

      this.getElevatorTypeList()
    },

    prev() {
      this.$router.go(-1)
    },
    check(value){
      console.log(value)
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .error_form .el-form-item__error{
  margin-left: 151px !important;
}
::v-deep .label .el-checkbox__label{
  line-height: 14px;
  padding-bottom: 15px;
  font-weight: bold;
  font-size: 16px;
}
.form-con {
  margin: 0 156px;
  margin-top: 5px;

  .type-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &>div {
      cursor: pointer;
      text-align: center;
      flex: 0 0 auto;
      padding: 0 20px;
      height: 54px;
      line-height: 54px;
      margin: 8px;
      border-radius: 4px;
      background: #fafafa;
      position: relative;

      &:hover {
        background: #fff1f0;
      }

      &.active {
        color: #e60027;
        background: #fff1f0;

        &::after {
          content: '✔';
          color: #fff;
          width: 20px;
          height: 14px;
          font-size: 12px;
          line-height: 14px;
          background: #e60027;
          border-radius: 0px 4px 0px 4px;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }

  .business-con {
    & ::v-deep .el-form-item {
      display: inline-block;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 30px;
  }

  ::v-deep .el-form-item__label {
    line-height: 14px;
    padding-bottom: 15px;
    font-weight: bold;
  }

  ::v-deep .check .el-checkbox {
    background-color: #FAFAFA;
    width: 160px;
    text-align: center;
    height: 54px;
    line-height: 54px;
    margin-bottom: 16px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.8500);

    &.is-checked {
      background-color: #FFF1F0;

      &::after {
        content: '✔';
        color: #fff;
        width: 20px;
        height: 14px;
        font-size: 12px;
        line-height: 14px;
        background: #e60027;
        border-radius: 0px 4px 0px 4px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    & .el-checkbox__input {
      display: none;
    }

    & .el-checkbox__label {
      padding-left: 0;
    }
  }
}
</style>
